'use es6';

import http from 'hub-http/clients/apiClient';
import getEarlyRequesterResult from 'pricing-pages-lib/api/getEarlyRequesterResult';
const ENDPOINT = 'hsfx/v1/eligibility/status';
export const getHsfsEligibility = () => {
  const earlyRequest = getEarlyRequesterResult(`HSFSApplicationStatus`);
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => http.get(ENDPOINT)) : null;
  return earlyRequestWithRetry || http.get(ENDPOINT);
};